import React from 'react';
import {Box, Typography, List, ListItem, Divider, ListItemText} from '@mui/material';
import { Question, TEST_STATE, TestSubmition } from '../../../../common/course';

const QuestionsList = ({question, answers}: {question: Question, answers: TestSubmition['answers']}) => {
    const answer = answers.find(answer => answer.id === question.id);
    const setOptionColor = (id: number): string => {
        if (answer?.choices.indexOf(id) !== -1) {
            if (answer?.isCorrect) {
                return 'success.main';
            }
            return 'error.main';
        }
        return 'inherit';
    }
    return (
        <List>
            {question.options.map(option => (
                <ListItem key={option.id}>
                    <ListItemText
                        sx={{
                            color: setOptionColor(option.id)
                        }}
                    >{option.value}</ListItemText>
                </ListItem>
            ))}
        </List>
    );
};
const View = ({testSubmition, setTestStatus, hideRetryMsg}: {testSubmition: TestSubmition, setTestStatus: Function, hideRetryMsg?: boolean}) => {
    let retryTime = 0;
    let timeFrame;
    const {questions, answers, submissionDate, retryIn} = testSubmition;
    const secondsInMin = 60;
    const secondsInHour = secondsInMin * 60;
    if (retryIn >= secondsInHour) {
        retryTime = Math.round(retryIn / secondsInHour);
        timeFrame = 'час(а)';
    } else if (retryIn >= secondsInMin) {
        retryTime = Math.round(retryIn / secondsInMin);
        timeFrame = 'минут(ы)';
    } else {
        retryTime = retryIn;
        timeFrame = 'секунд(ы)';
    }
    if (retryTime <= 0) {
        setTestStatus(TEST_STATE.NOT_STARTED);
    }

    const retryInMsg = <span>Повтори материалы этого урока и вернись к тесту через <strong>{retryTime} {timeFrame}</strong>, чтобы попробовать еще раз.</span>
    return (
        <Box sx={{pb: 3}}>
            <Typography
                component='h3'
                sx={{
                textAlign: 'center',
                color: 'error.main',
                fontSize: '3rem',
                my: 5,
                }}
            >
                Упс! Кажется, что-то пошло не так...
            </Typography>
            <Typography sx={{textAlign: 'center', mb: 3}}>
            Не расстраивайся, ошибки - это прекрасно, так как это самый лучший вариант узнать или научиться чему-то новому. {!hideRetryMsg && retryInMsg}
            </Typography>
            <List>
                {questions.map((question, index) => (
                    <React.Fragment key={question.id}>
                        <ListItem sx={{flexDirection: 'column', alignItems: 'flex-start'}}>
                            <ListItemText primary={question.content} />
                            <Box>
                                <QuestionsList question={question} answers={answers}/>
                            </Box>
                        </ListItem>
                        <Divider component="li" />
                    </React.Fragment>
                ))}
            </List>
        </Box>
    );
}

export default View;